@if (visible()) {
  <button
    #entry
    type="button"
    class="chat-entry"
    [class.desktop]="isDesktop()"
    (click)="open($event)"
    aria-haspopup="dialog"
    [attr.aria-expanded]="chat.isOpen()"
  >
    <span class="sparkle-circle" aria-hidden="true"><span class="sparkle"></span></span>
    <span #card class="chat-card">
      @if (isDesktop()) {
        <strong>Fragen zu dieser Aktie?</strong> Frag unsere neue AI.
      } @else {
        <strong>Fragen zur Aktie?</strong> Frag unsere neue AI.
      }
    </span>
  </button>
}
